

// // import React, { useEffect, useState, useMemo } from "react";
// // import { useLoader } from '../../../../context/LoaderProvider.jsx';
// // import {
// //     getEngineeringSubscriptionsAPI,
// // } from "../../../Servicefile/clientManagementService.jsx";
// // const Engeeniringsubscribedclinets = () => {
// //     const [data, setData] = useState([]);
// //     const [screenWidth, setScreenWidth] = useState(window.innerWidth);
// //     const [selectedStatusFilter, setSelectedStatusFilter] = useState("");
// //     const [selectedCityFilter, setSelectedCityFilter] = useState("");
// //     const [selectedBusinessVerticalFilter, setSelectedBusinessVerticalFilter] = useState("");

// //     // Search filters - same as FoodPaidClents
// //     const [searchType, setSearchType] = useState("vendorId");
// //     const [searchQuery, setSearchQuery] = useState("");

// //     const { showLoader, hideLoader } = useLoader();
// //     const [error, setError] = useState(null);

// //     // Business Vertical options
// //     const businessVerticalOptions = [
// //         "FOOD_AND_BEVERAGES",
// //         "CATERINGS_SERVICES",
// //         "LOGISTICS_SUPPLY",
// //         "FRESH_GROCERIES"
// //     ];

// //     // Search options - same as FoodPaidClents
// //     const searchOptions = [
// //         { value: "vendorId", label: "Vendor ID" },
// //         { value: "name", label: "Customer Name" },
// //         { value: "email", label: "Email" },
// //         { value: "phoneNumber", label: "Mobile Number" },
// //         { value: "city", label: "City" }
// //     ];

// //     useEffect(() => {
// //         const handleResize = () => setScreenWidth(window.innerWidth);
// //         window.addEventListener("resize", handleResize);
// //         return () => window.removeEventListener("resize", handleResize);
// //     }, []);

// //     const formatShortDate = (isoString) => {
// //         if (!isoString) return "—";
// //         try {
// //             return new Date(isoString)
// //                 .toLocaleDateString("en-GB", {
// //                     day: "2-digit",
// //                     month: "2-digit",
// //                     year: "2-digit",
// //                 })
// //                 .replaceAll("/", "-");
// //         } catch (e) {
// //             return "—";
// //         }
// //     };

// //     // Get placeholder text based on search type
// //     const getPlaceholderText = () => {
// //         switch (searchType) {
// //             case "vendorId": return "Search Vendor ID";
// //             case "name": return "Search Customer Name";
// //             case "email": return "Search Email";
// //             case "phoneNumber": return "Search Mobile Number";
// //             case "city": return "Search City";
// //             default: return "Search...";
// //         }
// //     };

// //     useEffect(() => {

// //         const fetchSubscriptions =
// //             async () => {

// //                 try {

// //                     showLoader();

// //                     const mappedData =
// //                         await getEngineeringSubscriptionsAPI();

// //                     setData(
// //                         mappedData
// //                     );

// //                     setError(null);

// //                 } catch (err) {

// //                     console.error(
// //                         "Error fetching subscriptions:",
// //                         err
// //                     );

// //                     setError(
// //                         err.message
// //                     );

// //                 } finally {

// //                     hideLoader();
// //                 }
// //             };

// //         fetchSubscriptions();

// //     }, []);

// //     // Get unique cities for filter
// //     const uniqueCities = useMemo(() => {
// //         const cities = data.map(item => item.city).filter(city => city && city !== "—");
// //         return [...new Set(cities)].sort();
// //     }, [data]);

// //     // Get unique statuses for filter
// //     const uniqueStatuses = useMemo(() => {
// //         const statuses = data.map(item => item.status).filter(Boolean);
// //         return [...new Set(statuses)].sort();
// //     }, [data]);

// //     // Get unique business verticals for filter
// //     const uniqueBusinessVerticals = useMemo(() => {
// //         const verticals = data.map(item => item.businessVertical).filter(Boolean);
// //         return [...new Set(verticals)].sort();
// //     }, [data]);

// //     // Apply filters - including search filters same as FoodPaidClents
// //     const filteredData = useMemo(() => {
// //         let result = data;

// //         // Apply status filter
// //         if (selectedStatusFilter) {
// //             result = result.filter(item =>
// //                 item.status && item.status.toLowerCase() === selectedStatusFilter.toLowerCase()
// //             );
// //         }

// //         // Apply city filter
// //         if (selectedCityFilter) {
// //             result = result.filter(item =>
// //                 item.city && item.city.toLowerCase() === selectedCityFilter.toLowerCase()
// //             );
// //         }

// //         // Apply business vertical filter
// //         if (selectedBusinessVerticalFilter) {
// //             result = result.filter(item =>
// //                 item.businessVertical === selectedBusinessVerticalFilter
// //             );
// //         }

// //         // Apply search query - same as FoodPaidClents
// //         if (searchQuery.trim()) {
// //             const query = searchQuery.toLowerCase().trim();
// //             result = result.filter(item => {
// //                 // Get the field value based on searchType
// //                 let fieldValue;

// //                 // Handle different field names
// //                 if (searchType === "vendorId") {
// //                     fieldValue = item.vendorId;
// //                 } else if (searchType === "phoneNumber") {
// //                     fieldValue = item.mobileNumber;
// //                 } else if (searchType === "email") {
// //                     fieldValue = item.email;
// //                 } else if (searchType === "name") {
// //                     fieldValue = item.vendorName;
// //                 } else if (searchType === "city") {
// //                     fieldValue = item.city;
// //                 } else {
// //                     fieldValue = item[searchType];
// //                 }

// //                 if (!fieldValue || fieldValue === "—") return false;

// //                 // For phone number search, clean non-digits
// //                 if (searchType === "phoneNumber") {
// //                     const cleanPartnerMobile = fieldValue.toString().replace(/\D/g, '');
// //                     const cleanQuery = query.replace(/\D/g, '');
// //                     return fieldValue.toString().toLowerCase().includes(query) ||
// //                         cleanPartnerMobile.includes(cleanQuery);
// //                 }

// //                 // For other fields
// //                 return fieldValue.toString().toLowerCase().includes(query);
// //             });
// //         }

// //         return result;
// //     }, [data, selectedStatusFilter, selectedCityFilter, selectedBusinessVerticalFilter, searchType, searchQuery]);

// //     // Clear all filters
// //     const clearAllFilters = () => {
// //         setSelectedStatusFilter("");
// //         setSelectedCityFilter("");
// //         setSelectedBusinessVerticalFilter("");
// //         setSearchQuery("");
// //         setSearchType("vendorId");
// //     };

// //     return (
// //         <div className="container-fluid">
// //             <div className="row">
// //                 <div className="col-lg-12" style={{ marginTop: "10px", }}>
// //                     {/* Filter Section - Same layout as FoodPaidClents */}
// //                     <div className="row g-2 mb-3 align-items-center me-0">
// //                         {/* Search Type Dropdown and Search Input - Side by Side */}
// //                         <div className="col-md-auto col-12">
// //                             <div className="d-flex align-items-center" style={{ gap: '10px' }}>
// //                                 {/* Search Type Dropdown */}
// //                                 <div style={{ minWidth: '150px' }}>
// //                                     <select
// //                                         className="form-select"
// //                                         value={searchType}
// //                                         onChange={(e) => setSearchType(e.target.value)}
// //                                         style={{ height: "40px" }}
// //                                     >
// //                                         {searchOptions.map(option => (
// //                                             <option key={option.value} value={option.value}>
// //                                                 {option.label}
// //                                             </option>
// //                                         ))}
// //                                     </select>
// //                                 </div>

// //                                 {/* Search Input */}
// //                                 <div style={{ minWidth: '200px' }}>
// //                                     <input
// //                                         type="text"
// //                                         className="form-control"
// //                                         placeholder={getPlaceholderText()}
// //                                         value={searchQuery}
// //                                         onChange={(e) => setSearchQuery(e.target.value)}
// //                                         style={{ height: "40px" }}
// //                                     />
// //                                 </div>
// //                             </div>
// //                         </div>



// //                         {/* Business Vertical Filter */}



// //                         {/* Clear Filters Button */}
// //                         <div className="col-md-auto col-12">
// //                             <button
// //                                 className="btn"
// //                                 onClick={clearAllFilters}
// //                                 style={{
// //                                     backgroundColor: '#6c757d',
// //                                     color: '#fff',
// //                                     height: "40px",
// //                                     padding: "0 15px"
// //                                 }}
// //                             >
// //                                 Clear Filters
// //                             </button>
// //                         </div>

// //                         {/* Refresh Data Button */}
// //                         <div className="col-md col-12">
// //                             <div className="d-flex justify-content-start justify-content-md-end">
// //                                 <button
// //                                     className="btn"
// //                                     onClick={() => window.location.reload()}
// //                                     style={{
// //                                         backgroundColor: 'rgb(230 109 51)',
// //                                         color: '#fff',
// //                                         height: "40px",
// //                                         padding: "0 20px"
// //                                     }}
// //                                 >
// //                                     Refresh Data
// //                                 </button>
// //                             </div>
// //                         </div>
// //                     </div>

// //                     <div
// //                         className="user-management-page"
// //                         style={{
// //                             overflowY: "auto",
// //                             height: "59vh",
// //                             scrollbarWidth: "thin",
// //                             marginTop: "15px",
// //                         }}
// //                     >
// //                         <div className="user-management-container" style={{ marginLeft: "0px" }}>
// //                             <div className="user-table-wrapper">
// //                                 <table style={{ width: "100%", fontSize: "0.9rem", borderCollapse: "collapse" }}>
// //                                     <thead>
// //                                         <tr>
// //                                             <th style={tableHeaderStyle}>S.NO</th>
// //                                             <th style={tableHeaderStyle}>Customer Name</th>
// //                                             <th style={tableHeaderStyle}>Vendor ID</th>
// //                                             <th style={tableHeaderStyle}>Email</th>
// //                                             <th style={tableHeaderStyle}>Phone</th>
// //                                             <th style={tableHeaderStyle}>City</th>
// //                                             <th style={tableHeaderStyle}>Vertical</th>
// //                                             <th style={tableHeaderStyle}>Billing Cycle</th>
// //                                             <th style={tableHeaderStyle}>Amount (₹)</th>
// //                                             <th style={tableHeaderStyle}>Start Date</th>
// //                                             <th style={tableHeaderStyle}>End Date</th>
// //                                             <th style={tableHeaderStyle}>Remaining</th>
// //                                             <th style={tableHeaderStyle}>Status</th>
// //                                         </tr>
// //                                     </thead>
// //                                     <tbody>
// //                                         {filteredData.length === 0 ? (
// //                                             <tr>
// //                                                 <td colSpan="13" style={tableCellStyle}>
// //                                                     {error
// //                                                         ? `⚠️ Error: ${error}`
// //                                                         : data.length === 0
// //                                                             ? "No subscription data found"
// //                                                             : "No data matches the selected filters"}
// //                                                 </td>
// //                                             </tr>
// //                                         ) : (
// //                                             filteredData.map((item, index) => (
// //                                                 <tr key={item.id}>
// //                                                     <td style={tableCellStyle}>
// //                                                         {index + 1}
// //                                                     </td>
// //                                                     <td style={tableCellStyle}>
// //                                                         <span style={{ fontWeight: "500" }}>
// //                                                             {item.vendorName}
// //                                                         </span>
// //                                                     </td>
// //                                                     <td style={tableCellStyle}>
// //                                                         {item.vendorId}
// //                                                     </td>
// //                                                     <td style={tableCellStyle}>
// //                                                         {item.email}
// //                                                     </td>
// //                                                     <td style={tableCellStyle}>
// //                                                         {item.mobileNumber}
// //                                                     </td>
// //                                                     <td style={tableCellStyle}>
// //                                                         {item.city}
// //                                                     </td>
// //                                                     <td style={tableCellStyle}>
// //                                                         {item.businessVertical}
// //                                                     </td>
// //                                                     <td style={tableCellStyle}>
// //                                                         {item.billingCycle}
// //                                                     </td>
// //                                                     <td style={{ ...tableCellStyle, fontWeight: "600", color: "#0b5e42" }}>
// //                                                         {item.totalAmount > 0
// //                                                             ? `₹${item.totalAmount.toLocaleString()}`
// //                                                             : "—"
// //                                                         }
// //                                                     </td>
// //                                                     <td style={tableCellStyle}>
// //                                                         {formatShortDate(item.startDate)}
// //                                                     </td>
// //                                                     <td style={tableCellStyle}>
// //                                                         {formatShortDate(item.endDate)}
// //                                                     </td>
// //                                                     <td style={tableCellStyle}>
// //                                                         <span style={{
// //                                                             color: item.remainingDays < 30 ? "#dc3545" : "#28a745",
// //                                                             fontWeight: "bold",
// //                                                             backgroundColor: item.remainingDays < 30 ? "#ffe6e6" : "#e6ffe6",
// //                                                             padding: "4px 8px",
// //                                                             borderRadius: "20px",
// //                                                             display: "inline-block"
// //                                                         }}>
// //                                                             {item.remainingDays || 0}d
// //                                                         </span>
// //                                                     </td>
// //                                                     <td style={tableCellStyle}>
// //                                                         <span style={{
// //                                                             padding: "4px 12px",
// //                                                             borderRadius: "20px",
// //                                                             backgroundColor:
// //                                                                 item.status === "ACTIVE" ? "#d4edda" :
// //                                                                     item.status === "EXPIRED" ? "#f8d7da" :
// //                                                                         item.status === "PENDING" ? "#fff3cd" :
// //                                                                             "#e2e3e5",
// //                                                             color:
// //                                                                 item.status === "ACTIVE" ? "#155724" :
// //                                                                     item.status === "EXPIRED" ? "#721c24" :
// //                                                                         item.status === "PENDING" ? "#856404" :
// //                                                                             "#383d41",
// //                                                             fontWeight: "600",
// //                                                             display: "inline-block"
// //                                                         }}>
// //                                                             {item.status}
// //                                                         </span>
// //                                                     </td>
// //                                                 </tr>
// //                                             ))
// //                                         )}
// //                                     </tbody>
// //                                 </table>
// //                             </div>
// //                         </div>
// //                     </div>
// //                 </div>
// //             </div>
// //         </div>
// //     );
// // };

// // // Styles
// // const tableHeaderStyle = {
// //     border: "1px solid #ddd",
// //     textAlign: "center",
// //     fontWeight: "bold",
// //     backgroundColor: "rgb(230 109 51)",
// //     color: "white",
// //     padding: "10px 6px",
// //     fontSize: "0.85rem",
// //     whiteSpace: "nowrap",
// //     position: "sticky",
// //     top: 0,
// //     zIndex: 10
// // };

// // const tableCellStyle = {
// //     border: "1px solid #ddd",
// //     textAlign: "center",
// //     padding: "10px 6px",
// //     fontSize: "0.85rem",
// //     verticalAlign: "middle",
// //     backgroundColor: "white"
// // };

// // export default Engeeniringsubscribedclinets;





// import React, { useEffect, useState, useMemo } from "react";
// import { useLoader } from '../../../../context/LoaderProvider.jsx';
// import {
//     getEngineeringSubscriptionsAPI,
// } from "../../../Servicefile/clientManagementService.jsx";

// // ============================================
// // PREMIUM ICONS COMPONENT
// // ============================================
// const Icons = {
//     Search: () => (
//         <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//             <circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/>
//         </svg>
//     ),
//     Refresh: () => (
//         <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//             <path d="M23 4v6h-6M1 20v-6h6"/>
//             <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/>
//         </svg>
//     ),
//     Clear: () => (
//         <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//             <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
//         </svg>
//     ),
//     Filter: () => (
//         <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//             <polygon points="22 3 2 3 10 13 10 21 14 18 14 13 22 3"/>
//         </svg>
//     ),
//     Active: () => (
//         <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
//             <polyline points="20 6 9 17 4 12"/>
//         </svg>
//     ),
//     Expired: () => (
//         <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//             <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
//         </svg>
//     ),
//     Pending: () => (
//         <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//             <circle cx="12" cy="12" r="10"/>
//             <polyline points="12 6 12 12 16 14"/>
//         </svg>
//     ),
//     Engineering: () => (
//         <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="rgb(230 109 51)" strokeWidth="2">
//             <path d="M12 2L2 7l10 5 10-5-10-5z"/>
//             <path d="M2 17l10 5 10-5"/>
//             <path d="M2 12l10 5 10-5"/>
//         </svg>
//     ),
//     NoData: () => (
//         <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#6c757d" strokeWidth="1.5">
//             <rect x="2" y="3" width="20" height="18" rx="2"/>
//             <line x1="8" y1="21" x2="16" y2="21"/>
//             <line x1="12" y1="17" x2="12" y2="21"/>
//             <path d="M8 7h8M8 11h6M8 15h4"/>
//         </svg>
//     ),
//     User: () => (
//         <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//             <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
//             <circle cx="12" cy="7" r="4"/>
//         </svg>
//     ),
//     Email: () => (
//         <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//             <rect x="2" y="4" width="20" height="16" rx="2"/>
//             <path d="M22 7l-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
//         </svg>
//     ),
//     Phone: () => (
//         <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//             <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.127.96.362 1.903.7 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.574 2.81.7A2 2 0 0 1 22 16.92z"/>
//         </svg>
//     ),
//     Calendar: () => (
//         <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
//             <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
//             <line x1="16" y1="2" x2="16" y2="6"/>
//             <line x1="8" y1="2" x2="8" y2="6"/>
//             <line x1="3" y1="10" x2="21" y2="10"/>
//         </svg>
//     ),
//     Money: () => (
//         <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#0b5e42" strokeWidth="2">
//             <circle cx="12" cy="12" r="10"/>
//             <path d="M8 12h8"/>
//             <path d="M12 8v8"/>
//         </svg>
//     )
// };

// // ============================================
// // PREMIUM STYLES
// // ============================================
// const styles = {
//     container: {
//         padding: '1px 5px',
      
//         minHeight: '500px'
//     },
//     header: {
//         display: 'flex',
//         justifyContent: 'space-between',
//         alignItems: 'center',
//         padding: '0 0 16px 0',
//         borderBottom: '2px solid #e9ecef',
//         flexWrap: 'wrap',
//         gap: '12px'
//     },
//     title: {
//         fontSize: '20px',
//         fontWeight: '600',
//         color: '#2d3748',
//         letterSpacing: '-0.3px',
//         display: 'flex',
//         alignItems: 'center',
//         gap: '10px'
//     },
//     titleBadge: {
//         background: 'rgb(230 109 51)',
//         color: 'white',
//         fontSize: '12px',
//         fontWeight: '500',
//         padding: '2px 12px',
//         borderRadius: '12px',
//         letterSpacing: '0.3px'
//     },
//     filtersContainer: {
//         display: 'flex',
//         flexWrap: 'wrap',
//         alignItems: 'center',
//         gap: '10px',
//         padding: '12px 0',
//         borderBottom: '1px solid #edf2f7',
//         marginBottom: '16px'
//     },
//     searchGroup: {
//         display: 'flex',
//         alignItems: 'center',
//         gap: '8px',
//         flex: '1 1 auto',
//         minWidth: '280px'
//     },
//     select: {
//         padding: '8px 12px',
//         border: '1px solid #e2e8f0',
//         borderRadius: '8px',
//         background: 'white',
//         fontSize: '13px',
//         fontWeight: '500',
//         color: '#2d3748',
//         outline: 'none',
//         transition: 'all 0.2s ease',
//         height: '38px',
//         minWidth: '140px',
//         cursor: 'pointer'
//     },
//     input: {
//         flex: '1',
//         padding: '8px 14px',
//         border: '1px solid #e2e8f0',
//         borderRadius: '8px',
//         fontSize: '13px',
//         color: '#2d3748',
//         outline: 'none',
//         transition: 'all 0.2s ease',
//         height: '38px',
//         background: 'white',
//         minWidth: '180px'
//     },
//     button: {
//         padding: '8px 16px',
//         borderRadius: '8px',
//         border: 'none',
//         fontWeight: '500',
//         fontSize: '13px',
//         display: 'flex',
//         alignItems: 'center',
//         gap: '6px',
//         cursor: 'pointer',
//         transition: 'all 0.2s ease',
//         height: '38px',
//         whiteSpace: 'nowrap'
//     },
//     buttonPrimary: {
//         background: 'rgb(230 109 51)',
//         color: 'white'
//     },
//     buttonSecondary: {
//         background: '#e2e8f0',
//         color: '#4a5568'
//     },
//     tableWrapper: {
//         borderRadius: '10px',
//         border: '1px solid #edf2f7',
//         background: 'white',
//         overflow: 'auto',
//         maxHeight: '500px',
//         position: 'relative'
//     },
//     table: {
//         width: '100%',
//         fontSize: '13px',
//         borderCollapse: 'collapse',
//         minWidth: '1200px'
//     },
//     thead: {
//         position: 'sticky',
//         top: 0,
//         zIndex: 10
//     },
//     th: {
//         padding: '10px 12px',
//         textAlign: 'left',
//         fontWeight: '600',
//         fontSize: '11px',
//         textTransform: 'uppercase',
//         letterSpacing: '0.5px',
//         color: 'white',
//         background: 'rgb(230 109 51)',
//         borderBottom: '2px solid #d45a1a',
//         whiteSpace: 'nowrap'
//     },
//     td: {
//         padding: '10px 12px',
//         borderBottom: '1px solid #f1f5f9',
//         color: '#2d3748',
//         fontSize: '13px'
//     },
//     statusBadge: {
//         display: 'inline-flex',
//         alignItems: 'center',
//         gap: '4px',
//         padding: '3px 12px',
//         borderRadius: '20px',
//         fontSize: '11px',
//         fontWeight: '500',
//         letterSpacing: '0.3px'
//     },
//     statusActive: {
//         background: '#c6f6d5',
//         color: '#276749'
//     },
//     statusExpired: {
//         background: '#fed7d7',
//         color: '#9b2c2c'
//     },
//     statusPending: {
//         background: '#fefcbf',
//         color: '#975a16'
//     },
//     statusDefault: {
//         background: '#e2e8f0',
//         color: '#4a5568'
//     },
//     remainingBadge: {
//         display: 'inline-flex',
//         alignItems: 'center',
//         justifyContent: 'center',
//         padding: '3px 10px',
//         borderRadius: '20px',
//         fontWeight: '600',
//         fontSize: '12px',
//         minWidth: '40px'
//     },
//     remainingLow: {
//         background: '#fed7d7',
//         color: '#9b2c2c'
//     },
//     remainingGood: {
//         background: '#c6f6d5',
//         color: '#276749'
//     },
//     emptyState: {
//         display: 'flex',
//         flexDirection: 'column',
//         alignItems: 'center',
//         justifyContent: 'center',
//         padding: '60px 20px',
//         color: '#a0aec0'
//     },
//     emptyStateText: {
//         marginTop: '16px',
//         fontSize: '16px',
//         fontWeight: '500',
//         color: '#4a5568'
//     },
//     emptyStateSubtext: {
//         fontSize: '13px',
//         color: '#a0aec0',
//         marginTop: '4px'
//     },
//     statsBar: {
//         display: 'flex',
//         alignItems: 'center',
//         gap: '16px',
//         padding: '8px 0 0 0',
//         fontSize: '12px',
//         color: '#718096',
//         flexWrap: 'wrap'
//     },
//     statItem: {
//         display: 'flex',
//         alignItems: 'center',
//         gap: '4px'
//     },
//     statNumber: {
//         fontWeight: '600',
//         color: '#2d3748'
//     },
//     amount: {
//         fontWeight: '600',
//         color: '#0b5e42'
//     },
//     verticalBadge: {
//         fontSize: '11px',
//         background: '#edf2f7',
//         padding: '2px 8px',
//         borderRadius: '4px',
//         color: '#4a5568',
//         display: 'inline-block'
//     }
// };

// const Engeeniringsubscribedclinets = () => {
//     const [data, setData] = useState([]);
//     const [screenWidth, setScreenWidth] = useState(window.innerWidth);
//     const [selectedStatusFilter, setSelectedStatusFilter] = useState("");
//     const [selectedCityFilter, setSelectedCityFilter] = useState("");
//     const [selectedBusinessVerticalFilter, setSelectedBusinessVerticalFilter] = useState("");

//     const [searchType, setSearchType] = useState("vendorId");
//     const [searchQuery, setSearchQuery] = useState("");

//     const { showLoader, hideLoader } = useLoader();
//     const [error, setError] = useState(null);

//     const businessVerticalOptions = [
//         "FOOD_AND_BEVERAGES",
//         "CATERINGS_SERVICES",
//         "LOGISTICS_SUPPLY",
//         "FRESH_GROCERIES"
//     ];

//     const searchOptions = [
//         { value: "vendorId", label: "Vendor ID" },
//         { value: "name", label: "Customer Name" },
//         { value: "email", label: "Email" },
//         { value: "phoneNumber", label: "Mobile Number" },
//         { value: "city", label: "City" }
//     ];

//     useEffect(() => {
//         const handleResize = () => setScreenWidth(window.innerWidth);
//         window.addEventListener("resize", handleResize);
//         return () => window.removeEventListener("resize", handleResize);
//     }, []);

//     const formatShortDate = (isoString) => {
//         if (!isoString) return "—";
//         try {
//             return new Date(isoString)
//                 .toLocaleDateString("en-GB", {
//                     day: "2-digit",
//                     month: "short",
//                     year: "numeric",
//                 });
//         } catch (e) {
//             return "—";
//         }
//     };

//     const getPlaceholderText = () => {
//         switch (searchType) {
//             case "vendorId": return "Search by Vendor ID...";
//             case "name": return "Search by Customer Name...";
//             case "email": return "Search by Email...";
//             case "phoneNumber": return "Search by Mobile...";
//             case "city": return "Search by City...";
//             default: return "Search...";
//         }
//     };

//     const getStatusStyle = (status) => {
//         if (!status) return styles.statusDefault;
//         const lower = status.toLowerCase();
//         if (lower === 'active') return styles.statusActive;
//         if (lower === 'expired') return styles.statusExpired;
//         if (lower === 'pending') return styles.statusPending;
//         return styles.statusDefault;
//     };

//     const getRemainingStyle = (days) => {
//         if (days < 30) return styles.remainingLow;
//         return styles.remainingGood;
//     };

//     useEffect(() => {
//         const fetchSubscriptions = async () => {
//             try {
//                 showLoader();
//                 const mappedData = await getEngineeringSubscriptionsAPI();
//                 setData(mappedData);
//                 setError(null);
//             } catch (err) {
//                 console.error("Error fetching subscriptions:", err);
//                 setError(err.message);
//             } finally {
//                 hideLoader();
//             }
//         };

//         fetchSubscriptions();
//     }, []);

//     const uniqueCities = useMemo(() => {
//         const cities = data.map(item => item.city).filter(city => city && city !== "—");
//         return [...new Set(cities)].sort();
//     }, [data]);

//     const uniqueStatuses = useMemo(() => {
//         const statuses = data.map(item => item.status).filter(Boolean);
//         return [...new Set(statuses)].sort();
//     }, [data]);

//     const uniqueBusinessVerticals = useMemo(() => {
//         const verticals = data.map(item => item.businessVertical).filter(Boolean);
//         return [...new Set(verticals)].sort();
//     }, [data]);

//     const filteredData = useMemo(() => {
//         let result = data;

//         if (selectedStatusFilter) {
//             result = result.filter(item =>
//                 item.status && item.status.toLowerCase() === selectedStatusFilter.toLowerCase()
//             );
//         }

//         if (selectedCityFilter) {
//             result = result.filter(item =>
//                 item.city && item.city.toLowerCase() === selectedCityFilter.toLowerCase()
//             );
//         }

//         if (selectedBusinessVerticalFilter) {
//             result = result.filter(item =>
//                 item.businessVertical === selectedBusinessVerticalFilter
//             );
//         }

//         if (searchQuery.trim()) {
//             const query = searchQuery.toLowerCase().trim();
//             result = result.filter(item => {
//                 let fieldValue;

//                 if (searchType === "vendorId") {
//                     fieldValue = item.vendorId;
//                 } else if (searchType === "phoneNumber") {
//                     fieldValue = item.mobileNumber;
//                 } else if (searchType === "email") {
//                     fieldValue = item.email;
//                 } else if (searchType === "name") {
//                     fieldValue = item.vendorName;
//                 } else if (searchType === "city") {
//                     fieldValue = item.city;
//                 } else {
//                     fieldValue = item[searchType];
//                 }

//                 if (!fieldValue || fieldValue === "—") return false;

//                 if (searchType === "phoneNumber") {
//                     const cleanPartnerMobile = fieldValue.toString().replace(/\D/g, '');
//                     const cleanQuery = query.replace(/\D/g, '');
//                     return fieldValue.toString().toLowerCase().includes(query) ||
//                         cleanPartnerMobile.includes(cleanQuery);
//                 }

//                 return fieldValue.toString().toLowerCase().includes(query);
//             });
//         }

//         return result;
//     }, [data, selectedStatusFilter, selectedCityFilter, selectedBusinessVerticalFilter, searchType, searchQuery]);

//     const clearAllFilters = () => {
//         setSelectedStatusFilter("");
//         setSelectedCityFilter("");
//         setSelectedBusinessVerticalFilter("");
//         setSearchQuery("");
//         setSearchType("vendorId");
//     };

//     // Calculate stats
//     const totalSubscriptions = data.length;
//     const activeCount = data.filter(item => item.status?.toLowerCase() === 'active').length;
//     const expiredCount = data.filter(item => item.status?.toLowerCase() === 'expired').length;
//     const pendingCount = data.filter(item => item.status?.toLowerCase() === 'pending').length;
//     const totalRevenue = data.reduce((sum, item) => sum + (item.totalAmount || 0), 0);

//     return (
//         <div style={styles.container}>
           
            

//             {/* Filters */}
//             <div style={styles.filtersContainer}>
//                 <div style={styles.searchGroup}>
//                     <select
//                         value={searchType}
//                         onChange={(e) => setSearchType(e.target.value)}
//                         style={styles.select}
//                     >
//                         {searchOptions.map(option => (
//                             <option key={option.value} value={option.value}>
//                                 {option.label}
//                             </option>
//                         ))}
//                     </select>

//                     <input
//                         type="text"
//                         placeholder={getPlaceholderText()}
//                         value={searchQuery}
//                         onChange={(e) => setSearchQuery(e.target.value)}
//                         style={{
//                             ...styles.input,
//                             borderColor: searchQuery ? 'rgb(230 109 51)' : '#e2e8f0'
//                         }}
//                     />
//                 </div>

//                 <select
//                     value={selectedStatusFilter}
//                     onChange={(e) => setSelectedStatusFilter(e.target.value)}
//                     style={{ ...styles.select, minWidth: '110px' }}
//                 >
//                     <option value="">All Status</option>
//                     {uniqueStatuses.map(status => (
//                         <option key={status} value={status}>{status}</option>
//                     ))}
//                 </select>

//                 <select
//                     value={selectedCityFilter}
//                     onChange={(e) => setSelectedCityFilter(e.target.value)}
//                     style={{ ...styles.select, minWidth: '110px' }}
//                 >
//                     <option value="">All Cities</option>
//                     {uniqueCities.map(city => (
//                         <option key={city} value={city}>{city}</option>
//                     ))}
//                 </select>

//                 <select
//                     value={selectedBusinessVerticalFilter}
//                     onChange={(e) => setSelectedBusinessVerticalFilter(e.target.value)}
//                     style={{ ...styles.select, minWidth: '130px' }}
//                 >
//                     <option value="">All Verticals</option>
//                     {uniqueBusinessVerticals.map(vertical => (
//                         <option key={vertical} value={vertical}>{vertical}</option>
//                     ))}
//                 </select>

//                 <button
//                     onClick={clearAllFilters}
//                     style={{ ...styles.button, ...styles.buttonSecondary }}
//                 >
//                     <Icons.Clear /> Clear
//                 </button>
//             </div>

//             {/* Table */}
//             <div style={styles.tableWrapper}>
//                 <table style={styles.table}>
//                     <thead style={styles.thead}>
//                         <tr>
//                             <th style={{ ...styles.th, width: '50px', textAlign: 'center' }}>#</th>
//                             <th style={styles.th}>Customer</th>
//                             <th style={styles.th}>Vendor ID</th>
//                             <th style={styles.th}>Email</th>
//                             <th style={styles.th}>Phone</th>
//                             <th style={styles.th}>City</th>
//                             <th style={styles.th}>Vertical</th>
//                             <th style={styles.th}>Billing</th>
//                             <th style={{ ...styles.th, textAlign: 'right' }}>Amount</th>
//                             <th style={styles.th}>Start</th>
//                             <th style={styles.th}>End</th>
//                             <th style={{ ...styles.th, textAlign: 'center' }}>Remaining</th>
//                             <th style={{ ...styles.th, textAlign: 'center' }}>Status</th>
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {filteredData.length === 0 ? (
//                             <tr>
//                                 <td colSpan="13" style={{ padding: 0 }}>
//                                     <div style={styles.emptyState}>
//                                         <Icons.NoData />
//                                         <div style={styles.emptyStateText}>
//                                             {error ? `⚠️ ${error}` : 
//                                              data.length === 0 ? 'No subscriptions found' : 'No data matches your filters'}
//                                         </div>
//                                         <div style={styles.emptyStateSubtext}>
//                                             {data.length === 0 
//                                                 ? 'Please wait while we fetch the data'
//                                                 : 'Try adjusting your filters to see more results'}
//                                         </div>
//                                     </div>
//                                 </td>
//                             </tr>
//                         ) : (
//                             filteredData.map((item, index) => (
//                                 <tr
//                                     key={item.id}
//                                     style={{
//                                         backgroundColor: index % 2 === 0 ? '#ffffff' : '#fafbfc',
//                                         transition: 'background 0.15s ease'
//                                     }}
//                                     onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f4ff'}
//                                     onMouseLeave={(e) => e.currentTarget.style.backgroundColor = index % 2 === 0 ? '#ffffff' : '#fafbfc'}
//                                 >
//                                     <td style={{ ...styles.td, textAlign: 'center', color: '#a0aec0' }}>
//                                         {index + 1}
//                                     </td>
//                                     <td style={{ ...styles.td, fontWeight: '500' }}>
//                                         {item.vendorName}
//                                     </td>
//                                     <td style={{ ...styles.td, fontFamily: 'monospace', fontSize: '12px' }}>
//                                         {item.vendorId}
//                                     </td>
//                                     <td style={{ ...styles.td, color: '#4a5568' }}>
//                                         {item.email}
//                                     </td>
//                                     <td style={styles.td}>
//                                         {item.mobileNumber}
//                                     </td>
//                                     <td style={styles.td}>
//                                         {item.city}
//                                     </td>
//                                     <td style={styles.td}>
//                                         <span style={styles.verticalBadge}>
//                                             {item.businessVertical}
//                                         </span>
//                                     </td>
//                                     <td style={styles.td}>
//                                         {item.billingCycle}
//                                     </td>
//                                     <td style={{ ...styles.td, textAlign: 'right', ...styles.amount }}>
//                                         {item.totalAmount > 0
//                                             ? `₹${item.totalAmount.toLocaleString()}`
//                                             : "—"
//                                         }
//                                     </td>
//                                     <td style={styles.td}>
//                                         {formatShortDate(item.startDate)}
//                                     </td>
//                                     <td style={styles.td}>
//                                         {formatShortDate(item.endDate)}
//                                     </td>
//                                     <td style={{ ...styles.td, textAlign: 'center' }}>
//                                         <span style={{
//                                             ...styles.remainingBadge,
//                                             ...getRemainingStyle(item.remainingDays)
//                                         }}>
//                                             {item.remainingDays || 0}d
//                                         </span>
//                                     </td>
//                                     <td style={{ ...styles.td, textAlign: 'center' }}>
//                                         <span style={{
//                                             ...styles.statusBadge,
//                                             ...getStatusStyle(item.status)
//                                         }}>
//                                             {item.status}
//                                         </span>
//                                     </td>
//                                 </tr>
//                             ))
//                         )}
//                     </tbody>
//                 </table>
//             </div>
//         </div>
//     );
// };

// export default Engeeniringsubscribedclinets;


import React, { useEffect, useState, useMemo, useRef } from "react";
import { useLoader } from '../../../../context/LoaderProvider.jsx';
import {
    getEngineeringSubscriptionsAPI,
} from "../../../Servicefile/clientManagementService.jsx";
import { Calendar, ChevronDown } from "lucide-react";

// ============================================
// PREMIUM ICONS COMPONENT
// ============================================
const Icons = {
    Search: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/>
        </svg>
    ),
    Refresh: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M23 4v6h-6M1 20v-6h6"/>
            <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/>
        </svg>
    ),
    Clear: () => (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/>
        </svg>
    ),
    Engineering: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="rgb(230 109 51)" strokeWidth="2">
            <path d="M12 2L2 7l10 5 10-5-10-5z"/>
            <path d="M2 17l10 5 10-5"/>
            <path d="M2 12l10 5 10-5"/>
        </svg>
    ),
    NoData: () => (
        <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#6c757d" strokeWidth="1.5">
            <rect x="2" y="3" width="20" height="18" rx="2"/>
            <line x1="8" y1="21" x2="16" y2="21"/>
            <line x1="12" y1="17" x2="12" y2="21"/>
            <path d="M8 7h8M8 11h6M8 15h4"/>
        </svg>
    ),
    Users: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
            <circle cx="9" cy="7" r="4"/>
            <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
            <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
        </svg>
    ),
    CheckCircle: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
            <polyline points="22 4 12 14.01 9 11.01"/>
        </svg>
    ),
    XCircle: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10"/>
            <line x1="15" y1="9" x2="9" y2="15"/>
            <line x1="9" y1="9" x2="15" y2="15"/>
        </svg>
    ),
    Clock: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10"/>
            <polyline points="12 6 12 12 16 14"/>
        </svg>
    ),
    Dollar: () => (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <circle cx="12" cy="12" r="10"/>
            <line x1="12" y1="2" x2="12" y2="22"/>
            <path d="M8 8h5a3 3 0 0 1 0 6h-5l5-6"/>
        </svg>
    ),
};

// Date filter options
const dateFilterOptions = ["All", "Today", "Yesterday", "This Week", "This Month", "Last Month", "This Year", "Custom Range"];

// ============================================
// PREMIUM STYLES
// ============================================
const styles = {
    container: {
        padding: '1px 5px',
        minHeight: '500px'
    },
    statsGrid: {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(160px, 1fr))',
        gap: '12px',
        marginTop: '12px'
    },
    statCard: {
        background: 'white',
        borderRadius: '12px',
        padding: '12px 16px',
        border: '1px solid #edf2f7',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        transition: 'all 0.2s ease'
    },
    statCardLeft: {
        display: 'flex',
        flexDirection: 'column'
    },
    statCardLabel: {
        fontSize: '11px',
        fontWeight: '500',
        color: '#94a3b8',
        textTransform: 'uppercase',
        letterSpacing: '0.3px'
    },
    statCardValue: {
        fontSize: '22px',
        fontWeight: '700',
        color: '#0f172a',
        marginTop: '2px',
        lineHeight: '1.2'
    },
    statCardIcon: {
        width: '36px',
        height: '36px',
        borderRadius: '10px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexShrink: 0
    },
    header: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '0 0 12px 0',
        borderBottom: '2px solid #e9ecef',
        flexWrap: 'wrap',
        gap: '12px'
    },
    title: {
        fontSize: '20px',
        fontWeight: '600',
        color: '#2d3748',
        letterSpacing: '-0.3px',
        display: 'flex',
        alignItems: 'center',
        gap: '10px'
    },
    titleBadge: {
        background: 'rgb(230 109 51)',
        color: 'white',
        fontSize: '12px',
        fontWeight: '500',
        padding: '2px 12px',
        borderRadius: '12px',
        letterSpacing: '0.3px'
    },
    filtersContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        gap: '10px',
        padding: '10px 0 12px 0',

    },
    searchGroup: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        flex: '1 1 auto',
        minWidth: '280px'
    },
    select: {
        padding: '8px 12px',
        border: '1px solid #e2e8f0',
        borderRadius: '8px',
        background: 'white',
        fontSize: '13px',
        fontWeight: '500',
        color: '#2d3748',
        outline: 'none',
        transition: 'all 0.2s ease',
        height: '38px',
        minWidth: '140px',
        cursor: 'pointer'
    },
    input: {
        flex: '1',
        padding: '8px 14px',
        border: '1px solid #e2e8f0',
        borderRadius: '8px',
        fontSize: '13px',
        color: '#2d3748',
        outline: 'none',
        transition: 'all 0.2s ease',
        height: '38px',
        background: 'white',
        minWidth: '180px'
    },
    button: {
        padding: '8px 16px',
        borderRadius: '8px',
        border: 'none',
        fontWeight: '500',
        fontSize: '13px',
        display: 'flex',
        alignItems: 'center',
        gap: '6px',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        height: '38px',
        whiteSpace: 'nowrap'
    },
    buttonPrimary: {
        background: 'rgb(230 109 51)',
        color: 'white'
    },
    buttonSecondary: {
        background: '#e2e8f0',
        color: '#4a5568'
    },
    dateFilterBtn: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        padding: '8px 16px',
        height: '38px',
        background: 'white',
        border: '1px solid #e2e8f0',
        borderRadius: '10px',
        fontSize: '13px',
        fontWeight: '500',
        cursor: 'pointer',
        transition: 'all 0.2s ease',
        color: '#334155'
    },
    dateFilterBtnActive: {
        borderColor: '#e66d33',
        color: '#e66d33'
    },
    tableWrapper: {
        borderRadius: '10px',
        border: '1px solid #edf2f7',
        background: 'white',
        overflow: 'auto',
        maxHeight: '500px',
        position: 'relative'
    },
    table: {
        width: '100%',
        fontSize: '13px',
        borderCollapse: 'collapse',
        minWidth: '1200px'
    },
    thead: {
        position: 'sticky',
        top: 0,
        zIndex: 10
    },
    th: {
        padding: '10px 12px',
        textAlign: 'left',
        fontWeight: '600',
        fontSize: '11px',
        textTransform: 'uppercase',
        letterSpacing: '0.5px',
        color: 'white',
        background: 'rgb(230 109 51)',
        borderBottom: '2px solid #d45a1a',
        whiteSpace: 'nowrap'
    },
    td: {
        padding: '10px 12px',
        borderBottom: '1px solid #f1f5f9',
        color: '#2d3748',
        fontSize: '13px'
    },
    statusBadge: {
        display: 'inline-flex',
        alignItems: 'center',
        gap: '4px',
        padding: '3px 12px',
        borderRadius: '20px',
        fontSize: '11px',
        fontWeight: '500',
        letterSpacing: '0.3px'
    },
    statusActive: {
        background: '#c6f6d5',
        color: '#276749'
    },
    statusExpired: {
        background: '#fed7d7',
        color: '#9b2c2c'
    },
    statusPending: {
        background: '#fefcbf',
        color: '#975a16'
    },
    statusDefault: {
        background: '#e2e8f0',
        color: '#4a5568'
    },
    remainingBadge: {
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '3px 10px',
        borderRadius: '20px',
        fontWeight: '600',
        fontSize: '12px',
        minWidth: '40px'
    },
    remainingLow: {
        background: '#fed7d7',
        color: '#9b2c2c'
    },
    remainingGood: {
        background: '#c6f6d5',
        color: '#276749'
    },
    emptyState: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '60px 20px',
        color: '#a0aec0'
    },
    emptyStateText: {
        marginTop: '16px',
        fontSize: '16px',
        fontWeight: '500',
        color: '#4a5568'
    },
    emptyStateSubtext: {
        fontSize: '13px',
        color: '#a0aec0',
        marginTop: '4px'
    },
    amount: {
        fontWeight: '600',
        color: '#0b5e42'
    },
    verticalBadge: {
        fontSize: '11px',
        background: '#edf2f7',
        padding: '2px 8px',
        borderRadius: '4px',
        color: '#4a5568',
        display: 'inline-block'
    }
};

const Engeeniringsubscribedclinets = () => {
    const [data, setData] = useState([]);
    const [screenWidth, setScreenWidth] = useState(window.innerWidth);
    const [selectedStatusFilter, setSelectedStatusFilter] = useState("");
    const [selectedCityFilter, setSelectedCityFilter] = useState("");
    const [selectedBusinessVerticalFilter, setSelectedBusinessVerticalFilter] = useState("");

    const [searchType, setSearchType] = useState("vendorId");
    const [searchQuery, setSearchQuery] = useState("");

    // Date filter states - Default "All"
    const [selectedDateFilter, setSelectedDateFilter] = useState("All");
    const [showDateDropdown, setShowDateDropdown] = useState(false);
    const [customFromDate, setCustomFromDate] = useState(() => {
        const date = new Date();
        date.setDate(1);
        return date.toISOString().split('T')[0];
    });
    const [customToDate, setCustomToDate] = useState(() => {
        return new Date().toISOString().split('T')[0];
    });
    const [showCustomPicker, setShowCustomPicker] = useState(false);
    const dateDropdownRef = useRef(null);

    const { showLoader, hideLoader } = useLoader();
    const [error, setError] = useState(null);

    // Stats
    const [stats, setStats] = useState({
        total: 0,
        active: 0,
        expired: 0,
        pending: 0,
        revenue: 0
    });

    const businessVerticalOptions = [
        "FOOD_AND_BEVERAGES",
        "CATERINGS_SERVICES",
        "LOGISTICS_SUPPLY",
        "FRESH_GROCERIES"
    ];

    const searchOptions = [
        { value: "vendorId", label: "Vendor ID" },
        { value: "name", label: "Customer Name" },
        { value: "email", label: "Email" },
        { value: "phoneNumber", label: "Mobile Number" },
        { value: "city", label: "City" }
    ];

    useEffect(() => {
        const handleResize = () => setScreenWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    // Close date dropdown
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dateDropdownRef.current && !dateDropdownRef.current.contains(event.target)) {
                setShowDateDropdown(false);
                setShowCustomPicker(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const formatShortDate = (isoString) => {
        if (!isoString) return "—";
        try {
            return new Date(isoString)
                .toLocaleDateString("en-GB", {
                    day: "2-digit",
                    month: "short",
                    year: "numeric",
                });
        } catch (e) {
            return "—";
        }
    };

    const getPlaceholderText = () => {
        switch (searchType) {
            case "vendorId": return "Search by Vendor ID...";
            case "name": return "Search by Customer Name...";
            case "email": return "Search by Email...";
            case "phoneNumber": return "Search by Mobile...";
            case "city": return "Search by City...";
            default: return "Search...";
        }
    };

    const getStatusStyle = (status) => {
        if (!status) return styles.statusDefault;
        const lower = status.toLowerCase();
        if (lower === 'active') return styles.statusActive;
        if (lower === 'expired') return styles.statusExpired;
        if (lower === 'pending') return styles.statusPending;
        return styles.statusDefault;
    };

    const getRemainingStyle = (days) => {
        if (days < 30) return styles.remainingLow;
        return styles.remainingGood;
    };

    // Get date range from selection - Returns null for "All"
    const getDateRangeFromSelection = () => {
        if (selectedDateFilter === "All") return null;

        const today = new Date();
        let from = new Date();
        let to = new Date();

        switch (selectedDateFilter) {
            case "Today":
                from = today;
                to = today;
                break;
            case "Yesterday":
                from.setDate(today.getDate() - 1);
                to.setDate(today.getDate() - 1);
                break;
            case "This Week": {
                const day = today.getDay();
                from.setDate(today.getDate() - day + (day === 0 ? -6 : 1));
                to = new Date(from);
                to.setDate(from.getDate() + 6);
                break;
            }
            case "This Month":
                from = new Date(today.getFullYear(), today.getMonth(), 1);
                to = new Date(today.getFullYear(), today.getMonth() + 1, 0);
                break;
            case "Last Month":
                from = new Date(today.getFullYear(), today.getMonth() - 1, 1);
                to = new Date(today.getFullYear(), today.getMonth(), 0);
                break;
            case "This Year":
                from = new Date(today.getFullYear(), 0, 1);
                to = new Date(today.getFullYear(), 11, 31);
                break;
            case "Custom Range":
                return { fromDate: customFromDate, toDate: customToDate };
            default:
                return null;
        }

        const formatDate = (date) => {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        };

        return {
            fromDate: formatDate(from),
            toDate: formatDate(to),
        };
    };

    // Filter by date range (frontend)
    const filterByDateRange = (items) => {
        const range = getDateRangeFromSelection();
        if (!range) return items;

        const startDate = new Date(range.fromDate);
        startDate.setHours(0, 0, 0, 0);
        const endDate = new Date(range.toDate);
        endDate.setHours(23, 59, 59, 999);

        return items.filter(item => {
            const registerDate = item.startDate ? new Date(item.startDate) : null;
            if (!registerDate) return false;
            return registerDate >= startDate && registerDate <= endDate;
        });
    };

    // Calculate Stats
    const calculateStats = (dataArray) => {
        const total = dataArray.length;
        const active = dataArray.filter(item => item.status?.toLowerCase() === 'active').length;
        const expired = dataArray.filter(item => item.status?.toLowerCase() === 'expired').length;
        const pending = dataArray.filter(item => item.status?.toLowerCase() === 'pending').length;
        const revenue = dataArray.reduce((sum, item) => sum + (item.totalAmount || 0), 0);

        setStats({ total, active, expired, pending, revenue });
    };

    useEffect(() => {
        const fetchSubscriptions = async () => {
            try {
                showLoader();
                const mappedData = await getEngineeringSubscriptionsAPI();
                setData(mappedData);
                calculateStats(mappedData);
                setError(null);
            } catch (err) {
                console.error("Error fetching subscriptions:", err);
                setError(err.message);
            } finally {
                hideLoader();
            }
        };

        fetchSubscriptions();
    }, []);

    const uniqueCities = useMemo(() => {
        const cities = data.map(item => item.city).filter(city => city && city !== "—");
        return [...new Set(cities)].sort();
    }, [data]);

    const uniqueStatuses = useMemo(() => {
        const statuses = data.map(item => item.status).filter(Boolean);
        return [...new Set(statuses)].sort();
    }, [data]);

    const uniqueBusinessVerticals = useMemo(() => {
        const verticals = data.map(item => item.businessVertical).filter(Boolean);
        return [...new Set(verticals)].sort();
    }, [data]);

    const filteredData = useMemo(() => {
        let result = data;

        // Apply date filter
        result = filterByDateRange(result);

        if (selectedStatusFilter) {
            result = result.filter(item =>
                item.status && item.status.toLowerCase() === selectedStatusFilter.toLowerCase()
            );
        }

        if (selectedCityFilter) {
            result = result.filter(item =>
                item.city && item.city.toLowerCase() === selectedCityFilter.toLowerCase()
            );
        }

        if (selectedBusinessVerticalFilter) {
            result = result.filter(item =>
                item.businessVertical === selectedBusinessVerticalFilter
            );
        }

        if (searchQuery.trim()) {
            const query = searchQuery.toLowerCase().trim();
            result = result.filter(item => {
                let fieldValue;

                if (searchType === "vendorId") {
                    fieldValue = item.vendorId;
                } else if (searchType === "phoneNumber") {
                    fieldValue = item.mobileNumber;
                } else if (searchType === "email") {
                    fieldValue = item.email;
                } else if (searchType === "name") {
                    fieldValue = item.vendorName;
                } else if (searchType === "city") {
                    fieldValue = item.city;
                } else {
                    fieldValue = item[searchType];
                }

                if (!fieldValue || fieldValue === "—") return false;

                if (searchType === "phoneNumber") {
                    const cleanPartnerMobile = fieldValue.toString().replace(/\D/g, '');
                    const cleanQuery = query.replace(/\D/g, '');
                    return fieldValue.toString().toLowerCase().includes(query) ||
                        cleanPartnerMobile.includes(cleanQuery);
                }

                return fieldValue.toString().toLowerCase().includes(query);
            });
        }

        return result;
    }, [data, selectedStatusFilter, selectedCityFilter, selectedBusinessVerticalFilter, searchType, searchQuery, selectedDateFilter, customFromDate, customToDate]);

    const clearAllFilters = () => {
        setSelectedStatusFilter("");
        setSelectedCityFilter("");
        setSelectedBusinessVerticalFilter("");
        setSearchQuery("");
        setSearchType("vendorId");
        setSelectedDateFilter("All");
        setCustomFromDate(() => {
            const date = new Date();
            date.setDate(1);
            return date.toISOString().split('T')[0];
        });
        setCustomToDate(new Date().toISOString().split('T')[0]);
    };

    const getDateFilterDisplayText = () => {
        if (selectedDateFilter === "All") return "All";
        if (selectedDateFilter === "Custom Range") {
            return `${customFromDate} to ${customToDate}`;
        }
        return selectedDateFilter;
    };

    const handleDateFilterSelect = (filter) => {
        setSelectedDateFilter(filter);
        if (filter === "Custom Range") {
            setShowCustomPicker(true);
        } else {
            setShowCustomPicker(false);
            setShowDateDropdown(false);
        }
    };

    const applyCustomRange = () => {
        setShowCustomPicker(false);
        setShowDateDropdown(false);
    };

    return (
        <div style={styles.container}>
            
            {/* Dashboard Stats Cards */}
            <div style={styles.statsGrid}>
                <div style={styles.statCard}>
                    <div style={styles.statCardLeft}>
                        <span style={styles.statCardLabel}>Total Subscriptions</span>
                        <span style={styles.statCardValue}>{stats.total}</span>
                    </div>
                    <div style={{ ...styles.statCardIcon, background: '#eef2ff' }}>
                        <Icons.Users />
                    </div>
                </div>
                <div style={styles.statCard}>
                    <div style={styles.statCardLeft}>
                        <span style={styles.statCardLabel}>Active</span>
                        <span style={{ ...styles.statCardValue, color: '#16a34a' }}>{stats.active}</span>
                    </div>
                    <div style={{ ...styles.statCardIcon, background: '#dcfce7' }}>
                        <Icons.CheckCircle />
                    </div>
                </div>
                <div style={styles.statCard}>
                    <div style={styles.statCardLeft}>
                        <span style={styles.statCardLabel}>Expired</span>
                        <span style={{ ...styles.statCardValue, color: '#dc2626' }}>{stats.expired}</span>
                    </div>
                    <div style={{ ...styles.statCardIcon, background: '#fee2e2' }}>
                        <Icons.XCircle />
                    </div>
                </div>
                <div style={styles.statCard}>
                    <div style={styles.statCardLeft}>
                        <span style={styles.statCardLabel}>Pending</span>
                        <span style={{ ...styles.statCardValue, color: '#f59e0b' }}>{stats.pending}</span>
                    </div>
                    <div style={{ ...styles.statCardIcon, background: '#fef3c7' }}>
                        <Icons.Clock />
                    </div>
                </div>
                <div style={styles.statCard}>
                    <div style={styles.statCardLeft}>
                        <span style={styles.statCardLabel}>Total Revenue</span>
                        <span style={{ ...styles.statCardValue, color: '#0b5e42' }}>
                            ₹{stats.revenue.toLocaleString()}
                        </span>
                    </div>
                    <div style={{ ...styles.statCardIcon, background: '#dcfce7' }}>
                        <Icons.Dollar />
                    </div>
                </div>
            </div>

            {/* Filters */}
            <div style={styles.filtersContainer}>
                <div style={styles.searchGroup}>
                    <select
                        value={searchType}
                        onChange={(e) => setSearchType(e.target.value)}
                        style={styles.select}
                    >
                        {searchOptions.map(option => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>

                    <input
                        type="text"
                        placeholder={getPlaceholderText()}
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        style={{
                            ...styles.input,
                            borderColor: searchQuery ? 'rgb(230 109 51)' : '#e2e8f0'
                        }}
                    />
                </div>

                {/* Date Filter */}
                <div ref={dateDropdownRef} style={{ position: "relative" }}>
                    <button
                        onClick={() => setShowDateDropdown(!showDateDropdown)}
                        style={{
                            ...styles.dateFilterBtn,
                            ...(showDateDropdown ? styles.dateFilterBtnActive : {})
                        }}
                    >
                        <Calendar size={14} color={showDateDropdown ? '#e66d33' : '#64748b'} />
                        <span>{getDateFilterDisplayText()}</span>
                        <ChevronDown size={14} color={showDateDropdown ? '#e66d33' : '#64748b'} />
                    </button>

                    {showDateDropdown && !showCustomPicker && (
                        <div style={{
                            position: "absolute",
                            top: "45px",
                            left: 0,
                            background: "white",
                            border: "1px solid #e2e8f0",
                            borderRadius: "12px",
                            boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
                            zIndex: 1000,
                            minWidth: "180px",
                            overflow: "hidden"
                        }}>
                            {dateFilterOptions.map(option => (
                                <div
                                    key={option}
                                    onClick={() => handleDateFilterSelect(option)}
                                    style={{
                                        padding: "10px 16px",
                                        fontSize: "13px",
                                        cursor: "pointer",
                                        background: selectedDateFilter === option ? "#fef3e8" : "white",
                                        color: selectedDateFilter === option ? "#e66d33" : "#334155",
                                        borderBottom: "1px solid #f0f0f0"
                                    }}
                                >
                                    {option}
                                </div>
                            ))}
                        </div>
                    )}

                    {showCustomPicker && (
                        <div style={{
                            position: "absolute",
                            top: "45px",
                            left: 0,
                            background: "white",
                            border: "1px solid #e2e8f0",
                            borderRadius: "12px",
                            boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
                            zIndex: 1000,
                            width: "280px",
                            padding: "16px"
                        }}>
                            <div style={{ marginBottom: "12px" }}>
                                <label style={{ fontSize: "12px", display: "block", marginBottom: "4px", color: "#64748b" }}>From Date</label>
                                <input
                                    type="date"
                                    value={customFromDate}
                                    onChange={(e) => setCustomFromDate(e.target.value)}
                                    style={{ width: "100%", padding: "8px", borderRadius: "8px", border: "1px solid #e2e8f0", fontSize: "13px" }}
                                    max={customToDate}
                                />
                            </div>
                            <div style={{ marginBottom: "16px" }}>
                                <label style={{ fontSize: "12px", display: "block", marginBottom: "4px", color: "#64748b" }}>To Date</label>
                                <input
                                    type="date"
                                    value={customToDate}
                                    onChange={(e) => setCustomToDate(e.target.value)}
                                    style={{ width: "100%", padding: "8px", borderRadius: "8px", border: "1px solid #e2e8f0", fontSize: "13px" }}
                                    min={customFromDate}
                                    max={new Date().toISOString().split('T')[0]}
                                />
                            </div>
                            <button
                                onClick={applyCustomRange}
                                style={{ width: "100%", padding: "10px", background: "#e66d33", color: "white", border: "none", borderRadius: "8px", fontSize: "13px", cursor: "pointer" }}
                            >
                                Apply Range
                            </button>
                        </div>
                    )}
                </div>

                <select
                    value={selectedStatusFilter}
                    onChange={(e) => setSelectedStatusFilter(e.target.value)}
                    style={{ ...styles.select, minWidth: '110px' }}
                >
                    <option value="">All Status</option>
                    {uniqueStatuses.map(status => (
                        <option key={status} value={status}>{status}</option>
                    ))}
                </select>

                <select
                    value={selectedCityFilter}
                    onChange={(e) => setSelectedCityFilter(e.target.value)}
                    style={{ ...styles.select, minWidth: '110px' }}
                >
                    <option value="">All Cities</option>
                    {uniqueCities.map(city => (
                        <option key={city} value={city}>{city}</option>
                    ))}
                </select>

                <select
                    value={selectedBusinessVerticalFilter}
                    onChange={(e) => setSelectedBusinessVerticalFilter(e.target.value)}
                    style={{ ...styles.select, minWidth: '130px' }}
                >
                    <option value="">All Verticals</option>
                    {uniqueBusinessVerticals.map(vertical => (
                        <option key={vertical} value={vertical}>{vertical}</option>
                    ))}
                </select>

                <button
                    onClick={clearAllFilters}
                    style={{ ...styles.button, ...styles.buttonSecondary }}
                >
                    <Icons.Clear /> Clear
                </button>

            </div>

            {/* Table */}
            <div style={styles.tableWrapper}>
                <table style={styles.table}>
                    <thead style={styles.thead}>
                        <tr>
                            <th style={{ ...styles.th, width: '50px', textAlign: 'center' }}>#</th>
                            <th style={styles.th}>Customer</th>
                            <th style={styles.th}>Vendor ID</th>
                            <th style={styles.th}>Email</th>
                            <th style={styles.th}>Phone</th>
                            <th style={styles.th}>City</th>
                            <th style={styles.th}>Vertical</th>
                            <th style={styles.th}>Billing</th>
                            <th style={{ ...styles.th, textAlign: 'right' }}>Amount</th>
                            <th style={styles.th}>Start</th>
                            <th style={styles.th}>End</th>
                            <th style={{ ...styles.th, textAlign: 'center' }}>Remaining</th>
                            <th style={{ ...styles.th, textAlign: 'center' }}>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filteredData.length === 0 ? (
                            <tr>
                                <td colSpan="13" style={{ padding: 0 }}>
                                    <div style={styles.emptyState}>
                                        <Icons.NoData />
                                        <div style={styles.emptyStateText}>
                                            {error ? `⚠️ ${error}` : 
                                             data.length === 0 ? 'No subscriptions found' : 'No data matches your filters'}
                                        </div>
                                        <div style={styles.emptyStateSubtext}>
                                            {data.length === 0 
                                                ? 'Please wait while we fetch the data'
                                                : 'Try adjusting your filters to see more results'}
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        ) : (
                            filteredData.map((item, index) => (
                                <tr
                                    key={item.id}
                                    style={{
                                        backgroundColor: index % 2 === 0 ? '#ffffff' : '#fafbfc',
                                        transition: 'background 0.15s ease'
                                    }}
                                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f0f4ff'}
                                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = index % 2 === 0 ? '#ffffff' : '#fafbfc'}
                                >
                                    <td style={{ ...styles.td, textAlign: 'center', color: '#a0aec0' }}>
                                        {index + 1}
                                    </td>
                                    <td style={{ ...styles.td, fontWeight: '500' }}>
                                        {item.vendorName}
                                    </td>
                                    <td style={{ ...styles.td, fontFamily: 'monospace', fontSize: '12px' }}>
                                        {item.vendorId}
                                    </td>
                                    <td style={{ ...styles.td, color: '#4a5568' }}>
                                        {item.email}
                                    </td>
                                    <td style={styles.td}>
                                        {item.mobileNumber}
                                    </td>
                                    <td style={styles.td}>
                                        {item.city}
                                    </td>
                                    <td style={styles.td}>
                                        <span style={styles.verticalBadge}>
                                            {item.businessVertical}
                                        </span>
                                    </td>
                                    <td style={styles.td}>
                                        {item.billingCycle}
                                    </td>
                                    <td style={{ ...styles.td, textAlign: 'right', ...styles.amount }}>
                                        {item.totalAmount > 0
                                            ? `₹${item.totalAmount.toLocaleString()}`
                                            : "—"
                                        }
                                    </td>
                                    <td style={styles.td}>
                                        {formatShortDate(item.startDate)}
                                    </td>
                                    <td style={styles.td}>
                                        {formatShortDate(item.endDate)}
                                    </td>
                                    <td style={{ ...styles.td, textAlign: 'center' }}>
                                        <span style={{
                                            ...styles.remainingBadge,
                                            ...getRemainingStyle(item.remainingDays)
                                        }}>
                                            {item.remainingDays || 0}d
                                        </span>
                                    </td>
                                    <td style={{ ...styles.td, textAlign: 'center' }}>
                                        <span style={{
                                            ...styles.statusBadge,
                                            ...getStatusStyle(item.status)
                                        }}>
                                            {item.status}
                                        </span>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default Engeeniringsubscribedclinets;